/**
 * Splits a flat list into rows of at most `perRow` items.
 *
 * Used by grid/list views that render through a single-column FlatList: chunking
 * into rows keeps `numColumns` constant across grid/list toggles (no remount or
 * header blink) and lets a partial last row stay left-aligned.
 */
export function chunkIntoRows<T>(items: T[], perRow: number): T[][] {
  const size = Math.max(1, perRow);
  const out: T[][] = [];
  for (let i = 0; i < items.length; i += size) {
    out.push(items.slice(i, i + size));
  }
  return out;
}
